import { gql } from 'graphql-request'

export const QueryLogo = gql`
  fragment FragmentLogos on LogoModelRecord {
    __typename
    id
    name
    svgIcon {
      url
      title
      width
      height
      alt
    }
    nonAutomated
  }
`
